import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ShowIcon from '@material-ui/icons/Visibility';
import HideIcon from '@material-ui/icons/VisibilityOff';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(
  ({ classes, params, onClickAction, showHide, disabled }) => {
    let showHideButton;
    let showHideText;
    if (showHide) {
      showHideButton = <ShowIcon className={classes.leftIcon} />;
      showHideText = `表示`;
    } else {
      showHideButton = <HideIcon className={classes.leftIcon} />;
      showHideText = `非表示`;
    }
    return (
      <Button
        onClick={() => {
          onClickAction(params);
        }}
        disabled={disabled}
      >
        {showHideButton}
        {showHideText}
      </Button>
    );
  }
);

export default withStyles(styles)(button);
